import { render, staticRenderFns } from "./LeaveBalanceEdit.vue?vue&type=template&id=14c4b1b1"
import script from "../../controllers/leave_balance/leave-balance-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/leave_balance/leave-balance-edit.js?vue&type=script&lang=js&external"
import style0 from "./LeaveBalanceEdit.vue?vue&type=style&index=0&id=14c4b1b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports